import { render, staticRenderFns } from "./heroesLeaderboard.vue?vue&type=template&id=885a6a4e&scoped=true"
import script from "./heroesLeaderboard.vue?vue&type=script&lang=js"
export * from "./heroesLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./heroesLeaderboard.vue?vue&type=style&index=0&id=885a6a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885a6a4e",
  null
  
)

export default component.exports